
const videoObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                // 可见区域后 下次不在执行监听
                target.play()
                videoObserver.unobserve(target)
            }
        })
    },
    {
        // 默认值为null，也就是视口区域,表示监听的可视区域为整个视口，也就是浏览器的可视区域
        root: null,
        // 属性决定了什么时候触发回调函数。默认为[0] 比如，[0, 0.25, 0.5, 0.75, 1]就表示当目标元素 0%、25%、50%、75%、100% 可见时，会触发回调函数。
        threshold: [0.75],
        // 定义根元素的margin,用来扩展可视区的范围,或者可以这样理解，root元素，多了一个margin属性，如果没有这个margin属性，
        // ele元素只有与root元素开始交叉时才会触发可视性的变化，而这个rootMargin属性的话，就是当ele元素与root元素的外边距交叉时，就会触发ele元素的可视性变化。
        rootMargin: '0px'
    }
)

let videos = document.querySelectorAll('.outer-video')
for(let video of videos){
    // console.log(video, '22222')
    videoObserver.observe(video)
}

(function(){
    $('#sideBtn').on('click',function(){
        let ele = $('.s7-maxv-serise-container');
        ele.hasClass('show') ? 
        ele.addClass('hide').removeClass('show') : 
        ele.addClass('show').removeClass('hide');
    });

    // 首页tab切换
    $('#popup-tab').delegate('.tabTitle', 'click', function(e) { 
        $(this).addClass("active").siblings().removeClass("active");
        $(".tabbody .tabCard").eq($(this).index()).show().siblings().hide();
        $(".popup-img img").eq($(this).index()).addClass("active").siblings().removeClass("active");
    })

    // 第二屏视频弹窗
    // $('.bl_de').on('click', function(event) {
    //     event.preventDefault();	
    //     event.stopPropagation();
    // }); 
    initYoutubevideos();
    $('.full_screen_video .full_video').on('click', function(event) {
        event.preventDefault();	
        event.stopPropagation();
    }); 
    $('.section-first .section-text .videoBtn').on('click', function(e) {
        $('.full_screen_video').show();
    });
    function closetan () {  
        $('.full_screen_video').hide();
        var e = new window.CustomEvent("hide.all.modals");
        document.dispatchEvent(e);
    }
    $('.full_screen_video').on('click', function(event) {
        closetan();
    });
    $('.full_screen_video .video-close').on('click', function(event) {
        closetan();
    });

    let windowInnerWidth = window.innerWidth;

    // 白天夜晚切换
    $('.video-img-area .sun-svg').on('click',function(){
        if(windowInnerWidth > 750){
            let ele = $('#section-forth')
            let top = ele.offset().top + ele.height() * 9 / 11 + 2
            window.scrollTo(0, top)
        } else {
            let ele = $('.video-img-area .section-sixth-bg')
            ele.attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg.jpg')
            $('.video-img-area .svg-area .sun-svg').css({opacity: '1'})
            $('.video-img-area .svg-area .moon-svg').css({opacity: '0.4'})
        }
    });
    $('.video-img-area .moon-svg').on('click',function(){
        if(windowInnerWidth > 750){
            let ele = $('#section-forth')
            let top = ele.offset().top + ele.height() * 9.5 / 11 + 2
            window.scrollTo(0, top)
        } else {
            let ele = $('.video-img-area .section-sixth-bg')
            ele.attr('src', 'https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/section-sixth-bg-dark.jpg')
            $('.video-img-area .svg-area .sun-svg').css({opacity: '0.4'})
            $('.video-img-area .svg-area .moon-svg').css({opacity: '1'})
        }
    });

    // 视频播放完毕自动跳转到图片部分
    if(windowInnerWidth > 750) {
        const videoEle = document.querySelector('.video-wrapper .behind-video')
        videoEle.addEventListener('timeupdate',function(){
            if(videoEle.duration === videoEle.currentTime) {
                let ele = $('#section-forth')
                let top = ele.offset().top + ele.height() * 9 / 11 + 2
                window.scrollTo({left: 0, top, behavior: 'smooth'})
            }
        });
    }

    //
    function IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        if(window.screen.width>=768){
             flag = true;
        }
        return flag;
    };
    if(!IsPC()){ // y移动端
        $('.bl_de').on('click', function(event) {
            event.preventDefault();	
            event.stopPropagation();
        }); 
        $('.section-second .section-text').on('touchstart', function(e) {
            $('#second_videobg')[0].play();
        });
    } else {
        $('.video-phone').hide();
    }
})();

function initYoutubevideos () {
    var e = document.querySelectorAll(".as-youtube-video");
    if (e.length > 0) {
      var t = document.createElement("script");
      t.src = "https://www.youtube.com/iframe_api";
      var n = document.getElementsByTagName("script")[0];
      n.parentNode.insertBefore(t, n);
      var i = [],
        r = function (e) {
          document.addEventListener("hide.all.modals", function (e) {
            for (var t, n = 0; n < i.length; n++)
              (t = i[n]), t.pauseVideo();
          });
        };
      window.onYouTubeIframeAPIReady = function () {
        for (var t = 0; t < e.length; t++)
          i.push(new window.YT.Player(e[t], { events: { onReady: r } }));
      };
    }
  };

function sectionFirstHandle () {
    console.log('window-onload')
    const canvas = document.getElementById("section-first-canvas");
    const parent = canvas.parentElement;
    let canvasWidth = 2560;
    let canvasHeight = 1200;
    let canvasOffsetX = 0;
    let canvasOffsetY = 0;
    let timer = null;
    let AnimationFrame = null;

    function winSize () {  
        // const Wwidth = window.innerWidth || document.documentElement.clientWidth;
        const Wwidth = parent.getBoundingClientRect().width;
        const Wheight = window.innerHeight || document.documentElement.clientHeight;
        // console.log('窗口', Wwidth, Wheight)
        if(Wwidth/Wheight > 32/15){
            canvasWidth = Wwidth;
            canvasHeight = Wwidth/(32/15);
        }else{
            canvasWidth = (32/15)*Wheight;
            canvasHeight = Wheight;
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        canvas.style.left = ((Wwidth - canvasWidth) / 2) + 'px';
        // canvas.style.top = '-3px';

        canvasOffsetX = canvas.offsetLeft;
        canvasOffsetY = canvas.offsetTop;
        
        // console.log('resize变化', canvasWidth, canvasHeight)
        loadGL();
    };
    winSize();
    window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            winSize();
        }, 500);
    }, false);
   
    let curCanvasPosPercent = {
        x: 0,
        y: 0,
    };

    window.addEventListener("mousemove", (e) => {
        curCanvasPosPercent.x = Math.max(Math.min(e.pageX - canvasOffsetX, canvasWidth), 0);
        curCanvasPosPercent.y = canvasHeight - Math.max(Math.min(e.pageY - canvasOffsetY, canvasHeight), 0);
    });

    async function loadGL () {
        const renderer = new GlRenderer(canvas);
        
        const program = await renderer.load("https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/fragmentShader.frag", ["https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/vertexShader.frag"]);
        renderer.useProgram(program);

        const texture = await renderer.loadTexture("https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/bannerhover.jpg");
        renderer.uniforms.tMap = texture;
        
        renderer.uniforms.canvasWidth = canvasWidth;
        renderer.uniforms.canvasHeight = canvasHeight;

        renderer.setMeshData([
            {
            positions: [
                [-1, -1],
                [-1, 1],
                [1, 1],
                [1, -1],
            ],
            attributes: {
                uv: [
                [0, 0],
                [0, 1],
                [1, 1],
                [1, 0],
                ],
            },
            cells: [
                [0, 1, 2],
                [2, 0, 3],
            ],
            },
        ]);

        renderer.render();

        function update() {
            renderer.uniforms.xPot = curCanvasPosPercent.x;
            renderer.uniforms.yPot = curCanvasPosPercent.y;
            AnimationFrame = requestAnimationFrame(update);
            
        }
        
        cancelAnimationFrame(AnimationFrame);
        update();
    };

}

function productSwiper() {  
    var swiper = new Swiper("#mySwiper", {
        slidesPerView: "auto",
        spaceBetween: '6%',
        navigation: {
            nextEl: "#goNext",
            prevEl: "#goPrev",
        },
    });
    
}

function sectionFirst() {
    var c = document.getElementById("section-first-canvas");
    var ctx = c.getContext("2d");
    var img1 = new Image();
    var flag = false
    var screenWidth = $(window).width()
    var screenHeight = $(window).height()
    c.width = screenWidth
    c.height = screenHeight
    img1.src='https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/bannerhover.jpg';
    img1.onload = function () {
        flag =true
    }

    $('#section-first-canvas').mousemove(function (e) {
        if(flag){
            ctx.clearRect(0, 0, screenWidth, screenWidth);
            ctx.beginPath();
            //应用fillStyle生成渐变
            // ctx.lineWidth = 10;
            // ctx.globalCompositeOperation = 'source-out';
            // ctx.shadowColor = '#2a2a2a'
            ctx.shadowBlur = 200;
            ctx.fillStyle = ctx.createPattern(img1, 'no-repeat');
            ctx.arc(getCanvasPos(c, e).x, getCanvasPos(c, e).y, 200, 0, Math.PI * 2, true);
            //ctx.stroke();
            ctx.fill();
        }
    });

    function getCanvasPos(canvas, e) {//获取鼠标在canvas上的坐标
        var rect = canvas.getBoundingClientRect();
        return {
            x: e.clientX - rect.left * (canvas.width / rect.width),
            y: e.clientY - rect.top * (canvas.height / rect.height)
        };
    }

    var imagesLength = 128;
    var width = 2560;
    var height = 820;
    var images = [];
    const baseUrl = 'https://www.apple.com.cn/105/media/us/airpods-pro/2019/1299e2f5_9206_4470_b28e_08307a42f19b/anim/sequence/large/02-head-bob-turn/';
    let imagesManager = [];
    let canvas = '';
    let CanvasRenderingContext2D = '';

    function initSectionCanvasImg(){
        for(let i = 0; i < imagesLength; i++) {
            images.push(baseUrl + numeral(i).format('0000') + '.jpg')
        }
        canvas = document.getElementById('section-1');
        CanvasRenderingContext2D = canvas.getContext('2d');
        // 加入scroll事件监听
        document.addEventListener('scroll', handleScroll)
        // 执行加载每一帧的所有图片
        loadImages();
    }

// 加载图片
    function loadImages() {
        function loadNextImage (src) {
            const img = new Image();
            // 这里是同步加载图片，有性能问题，可优化为异步
            img.onload = (e) => {
                imagesManager.push(img)
                if(imagesManager.length === imagesLength) {
                    // 所有图片加载完成后回调方法
                    imagesLoadComplete()
                }
            }
            img.src = src;
            if(images.length === 0) return;
            loadNextImage(images.shift())
        }
        loadNextImage(images.shift());
    }

    initSectionCanvasImg()

    let scrollIndex = 0; // 当前滚动进度待显示的图片索引值
    let currentIndex = 0; // 当前显示的图片索引值
    let raf = null;

    function imagesLoadComplete(){
        console.log('images all loaded!')
        run()
    }
    function run() {
        raf = window.requestAnimationFrame(draw)
    }
    function draw() {
        if(currentIndex <= scrollIndex) {
            drawImages(imagesManager[currentIndex])
            currentIndex + 1 < scrollIndex && currentIndex++;
        } else if(currentIndex >= scrollIndex){
            drawImages(imagesManager[currentIndex])
            currentIndex - 1 > scrollIndex && currentIndex--;
        }
        raf = window.requestAnimationFrame(draw)
    }

    function handleScroll() {
        const docElement = document.documentElement;
        const scrollHeight = docElement.scrollHeight;
        const clientHeight = docElement.clientHeight;
        const scrollTop = docElement.scrollTop;
        // 根据滚动距离，等比例算出应该滚动到第几张图
        scrollIndex = Math.round(scrollTop * imagesLength / (scrollHeight - clientHeight));
    }

    function drawImages(img) {
        CanvasRenderingContext2D.clearRect(0, 0, width, height);
        CanvasRenderingContext2D.drawImage(img, 0, 0);
    }
}


window.onload = function(){
    sectionFirstHandle()
    !0 !== aeHandleCompleted && handleComplete();
    productSwiper()

    // sectionFirst()
}
